import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Box } from '@mui/material';

import DataGrid from '../../components/DataGrid/DataGrid';
import Chip from '../../components/common/Chip';
import { loan } from '../../utils/api';

export default function MultipleClients(props) {
  const history = useHistory();
  const columns = [
    {
      field: 'id',
      headerName: 'ID zapytania',
      type: 'string',
      renderCell: (params) => {
        return (
          <>
            <Chip
              key={params.row.id}
              label={`Zapytanie ${params.row.id}`}
              onClick={() =>
                history.push(`/dashboard/individual-client/${params.row.id}`)
              }
            />
          </>
        );
      },
      headerAlign: 'center',
      align: 'center',
      minWidth: 150,
      flex: 1,
      filterable: false,
      getApplyQuickFilterFn: undefined,
    },
    {
      field: 'name',
      headerName: 'Imię i nazwisko',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'loanType',
      headerName: 'Kategoria',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {params.value === 'equipment' && 'Sprzęt'}
            {params.value === 'realEstate' && 'Nieruchomości'}
            {params.value === 'revolvingLoan' && 'Kredyt obrotowy'}
          </>
        );
      },
    },
    {
      field: 'email',
      headerName: 'E-mail',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'incomeGroup',
      headerName: 'Grupa dochodowa',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {params.value === 'micro' && 'Mikro'}
            {params.value === 'medium' && 'Średnia'}
            {params.value === 'macro' && 'Makro'}
          </>
        );
      },
    },
    {
      field: 'isProductionExcluded',
      headerName: 'Branża wykluczona',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{params.value ? 'Tak' : 'Nie'}</>;
      },
    },
    {
      field: 'fieldsArea',
      headerName: 'Powierzchnia upraw (ha)',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'voivodeship',
      headerName: 'Województwo',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'county',
      headerName: 'Powiat',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'commune',
      headerName: 'Gmina',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'region',
      headerName: 'Obręb',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'isCropProduction',
      headerName: 'Produkcja roślinna',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{params.value ? 'Tak' : 'Nie'}</>;
      },
    },
    {
      field: 'directPaymentIncome',
      headerName: 'Produkcja roślinna (zł)',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'isAnimalProduction',
      headerName: 'Produkcja zwierzęca',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{params.value ? 'Tak' : 'Nie'}</>;
      },
    },
    {
      field: 'animalProductionIncome',
      headerName: 'Produkcja zwierzęca (zł)',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'liabilitiesValue',
      headerName: 'Wartość zadłużenia (zł)',
      minWidth: 150,
      flex: 1,
    },
  ];

  const [data, setData] = useState([]);
  useEffect(() => {
    loan
      .getAll()
      .then((result) => {
        setData(
          result.data.map((item, index) => {
            return { ...item, name: item.name + ' ' + item.surname };
          })
        );
      })
      .catch((err) => {});
  }, []);

  return (
    <Box sx={{ mt: 10 }}>
      <DataGrid
        toolbar
        columnData={columns}
        rowData={data?.sort((a, b) => a.id - b.id)}
        sx={{ boxShadow: 3 }}
        componentsProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
      />
    </Box>
  );
}
